import { useRef } from "react";
import MaterialTable from "material-table";
import { Paper } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import _ from "lodash";

import Helper from "../../Helper";
import authHeader from "../../services/auth-header";
import { getTrans as t } from "../../Localization/translations";
import { API } from "../../backend";

function Transaction() {
  const tableRef = useRef();
  const ENABLED = {
    Y: "Yes",
    N: "No",
  };

  return (
    <div className="container-fluid py-4 pt-2">
      <div className="row py-2 mt-2">
        <ToastContainer />
        <div className="col-md-12">
          <div className=" mb-0">
            <div className="header pb-0">
              <div className="d-lg-flex">
                <div>
                  <h5 className="mb-0 tc">{t("Transaction")}</h5>
                </div>
              </div>
            </div>
            <div className="body">
              <div className="p-0">
                <MaterialTable
                  tableRef={tableRef}
                  style={{
                    padding: "0.5rem 0.5rem",
                    backgroundColor: "var(--bs-table-bg)",
                    borderBottomWidth: "1px",
                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                  }}
                  columns={[
                    {
                      title: `${t("Transaction Type")}`,
                      field: "transactiontypes",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none ">{t("Transaction Type")}</div>
                          <div>{rowData.transactiontypes}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Transaction Date")}`,
                      field: "transaction_date",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Date")}</div>
                          <div>{Helper.DateNormal(rowData.transaction_date)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Total Income")}`,
                      field: "total_income",
                      render: (rowData) => (
                        <>
                          <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                          >{t("Total Income")}</div>
                          <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.total_income)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Gross Rent")}`,
                      field: "gross_rent",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Gross Rent")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                          {Helper.Amount(rowData.gross_rent)}
                        </div></>
                      ,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Residual Value")}`,
                      field: "residual_value",
                      render: (rowData) =>
                        <>
                          <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                          >{t("Residual Value")}</div>
                          <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.residual_value)}
                          </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Total Principal")}`,
                      field: "total_principal",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Total Principal")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.total_principal)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Total Interest")}`,
                      field: "total_interest",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Total Interest")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.total_interest)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Accrual Amount")}`,
                      field: "accrual_amount",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Accrual Amount")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.accrual_amount)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Contract")}`,
                      field: "contract_id.contract_number",
                      render: (rowData) => <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Contract")}</div>
                        <div> {rowData.contract_id.contract_number !== "" ? rowData.contract_id.contract_number : "None"}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Asset Cost")}`,
                      field: "asset_cost",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Asset Cost")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.asset_cost)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Invoice Amount")}`,
                      field: "invoice_amount",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Invoice Amount")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.invoice_amount)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Tax Amount")}`,
                      field: "tax_amount",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Invoice Amount")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.tax_amount)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Total Invoice Amount")}`,
                      field: "total_invoice_amount",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Total Invoice Amount")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.total_invoice_amount)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Receipt Amount")}`,
                      field: "receipt_amount",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Receipt Amount")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.receipt_amount)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Applied Amount ")}`,
                      field: "applied_amount",
                      render: (rowData) => <>
                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                        >{t("Applied Amount ")}</div>
                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.applied_amount)}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Accounted")}`,
                      field: "accounted_yn",
                      render: (rowData) => <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Accounted")}</div>
                        <div> {ENABLED[rowData.accounted_yn]}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      let url = API + "accounting/transaction/?";
                      url += "per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);
                      fetch(url, { headers: authHeader() })
                        .then((response) => response.json())
                        .then((result) => {
                          resolve({
                            data:
                              query.orderBy && query.orderDirection
                                ? _.orderBy(
                                  result.data,
                                  [query.orderBy.field],
                                  [query.orderDirection]
                                )
                                : result.data,
                            page: result.page - 1,
                            totalCount: result.total,
                          });
                        });
                    })
                  }
                  components={{
                    Container: (props) => (
                      <div id="Payment">
                        <Paper {...props} />
                      </div>
                    ),
                  }}
                  options={{
                    headerStyle: {
                      backgroundColor: "white",
                      color: "#245C7F",
                      fontSize: 12,
                    },
                    rowStyle: (rowData, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#fff" };
                      }
                    },
                    sorting: true,
                    search: false,
                    toolbar: false,
                    paging: true,
                    pageSize: 10,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [10, 15, 20, 50],
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    actionsColumnIndex: -1,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transaction;
